import { useGetAssessmentProgresses } from "@/api/console/assessment-progresses/useGetAssessmentProgresses";
import AdminNavbar from "@/components/AdminNavbar/AdminNavbar";
import { STATUS } from "@/config/progress";
import AssessmentTable from "@/src/console/(auth)/(confirm-assessments)/assessments/_components/AssessmentTable";
import { useTranslation } from "react-i18next";

function ConfirmAssessments() {
  const { t } = useTranslation();
  const { data, isLoading } = useGetAssessmentProgresses(
    `${STATUS.IMPROVEMENT_PROPOSAL_COMPLETED}`,
  );

  const assessments = data?.data || [];

  const breadcrumbs = [
    {
      name: t("confirm-assessments"),
      href: "/console/confirm-assessments",
    },
  ];

  return (
    <>
      <AdminNavbar breadcrumbs={breadcrumbs} />
      <div className=" mx-6 mt-8 my-heading">{t("assessment")}</div>
      <div className="mx-6 my-8">
        <AssessmentTable data={assessments} isLoading={isLoading} />
      </div>
    </>
  );
}

export default ConfirmAssessments;
